import React from 'react';
import { Box, Card, Flex, Text, Button } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const GuardianIntroduction = () => {
  const guardian = useSelector((state) => state.guardian);

  return (
    <Box>
      <Flex direction="column" justify="start" align="start" p="4" gap="4">
        <Text size="3" weight="bold" align="start">Welcome to Your Guardian Dashboard</Text>
        
        <Text color="gray" align="left" size="2">
          To get started, you'll need to add your wards to your account. 
          This will allow you to monitor their learning progress and performance.
        </Text>

          <Button asChild size="3">
            <Link to="/guardian/students">
              Add Students
            </Link>
          </Button>

        <Text size="2" color="gray">
          Need help? Contact support for assistance.
        </Text>
      </Flex>
    </Box>
  );
};

export default GuardianIntroduction;
